import styled, { css } from 'styled-components';
import { Link } from '@unimed-fesp/components';
import ImagemLogin from '../../assets/images/login/imagem-login.svg';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  height: 100vh;
  overflow-y: hidden;
`;

export const HeaderContainer = styled.div`
  margin-left: 60px;
  margin-top: 3%;

  ${({ display }) =>
    display
      ? css`
          display: ${display};
        `
      : css`
          display: flex;
        `}
`;

export const AutenticacaoStructure = styled.div`
  grid-template-rows: 13% 20% 5% 65%;
  background-color: #ffff;

  ${({ display }) =>
    display
      ? css`
          display: ${display};
        `
      : ''};
        }

  img {
    padding: 5% 16.5% 0 60px;
  }
`;

export const ImageStructure = styled.div`
  background: url(${ImagemLogin});
  background-repeat: no-repeat;
  background-position: bottom;
  background-position-x: left;
  background-size: cover;
  background-color: #ffff;
`;

export const LoginLink = styled(Link).attrs((props) => ({
  login: true,
  title: props.title,
}))``;

export const DificuldadesAcessoContainer = styled.div`
  display: flex;
  margin-left: 104px;
`;
